import { formatName } from '../../core/user';
import { Organization, Payment } from '../../types';
import Money from '../../utils/Money';
import { AddressComponent } from '../components/address.template';
import { OrganizationComponent } from '../components/organization.template';
import { DocumentTypePopulator } from '../DocumentGenerator';

import { applyTableMetadata, formatCurrency, formatDate, getPrimaryBusiness } from './formatters';

export type RemittanceInputType = {
  slug: string;
  issuedDate: string | Date;
  organization: Organization;
  payments: Payment[];
};

export const RemittanceTemplate: DocumentTypePopulator<RemittanceInputType, void, any> = {
  populate: (remittance, { type, templateId }, globalOptions) => {
    if (!remittance) return {};

    const org = remittance.organization;
    const payment = remittance.payments[0];

    const buyer = payment.childPayments
      ?.flatMap((cp) => cp.bill?.attachedOrders ?? [])
      ?.find((o) => !!o.purchaseOrder?.buyer)?.purchaseOrder?.buyer;

    return {
      orgLogo: org?.logoUrl,
      organization: OrganizationComponent.templatize({ organization: org, customOrgName: globalOptions.customOrgName }),
      allocations: applyTableMetadata(
        (payment.childPayments ?? []).map((child) => ({
          slug: child.bill?.slug,
          reference: child.bill?.reference ?? '--',
          invoiceDate: formatDate(child.bill?.invoiceDate),
          totalAmountDue: formatCurrency(Money.toDollars(child.bill?.view?.totalAmountDue ?? 0)),
          paymentAmount: formatCurrency(Money.toDollars(child.paymentAmount)),
        }))
      ),
      buyer: formatName(buyer?.user, ''),
      email: buyer?.user?.email,

      businessAddress: AddressComponent.templatize(getPrimaryBusiness(org)),
      phoneNumber: getPrimaryBusiness(org)?.phone,
      sendTo: payment.payee?.name,
      remittanceNumber: remittance.slug,
      paymentTotal: formatCurrency(Money.toDollars(payment.paymentAmount)),
      issuedDate: formatDate(remittance.issuedDate),
      paymentMethod: payment.paymentMethod,
      paymentDate: formatDate(payment.paymentDate),
      notes: applyTableMetadata([]),
    };
  },
};
